import { useUser } from './UserContext'

export default function OrgGuard({ children }) {
  const { profile, loadingProfile } = useUser()

  if (loadingProfile) return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#F8FAFD',
      fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
    }}>
      <div style={{ textAlign: 'center', color: '#64748B', fontSize: '13px', fontWeight: 600 }}>
        <img
          src="/logo-delivr.svg"
          alt="Delivr"
          style={{ width: '118px', height: 'auto', display: 'block', margin: '0 auto 18px' }}
        />
        Loading...
      </div>
    </div>
  )

  if (profile && !profile.org_id) return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#F8FAFD',
      fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif', padding: '24px'
    }}>
      <div style={{
        background: '#fff', borderRadius: '12px', padding: '40px',
        maxWidth: '420px', width: '100%', textAlign: 'center',
        border: '1px solid #E4E8F0', boxShadow: '0 4px 12px rgba(15,21,35,0.08)'
      }}>
        <div style={{
          width: '48px', height: '48px', background: '#FEF3C7',
          borderRadius: '10px', display: 'flex', alignItems: 'center',
          justifyContent: 'center', margin: '0 auto 20px'
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <h2 style={{ fontSize: '18px', fontWeight: '600', color: '#0F1523', marginBottom: '10px' }}>
          No workspace found
        </h2>
        <p style={{ fontSize: '14px', color: '#5A6478', lineHeight: '1.6', marginBottom: '24px' }}>
          Your account isn't linked to a workspace. You may have signed up without an invite link. Please contact your workspace admin to be added.
        </p>
        <a
          href="mailto:support@delivr.app"
          style={{
            display: 'inline-block', background: '#4F6EF7', color: '#fff',
            padding: '10px 20px', borderRadius: '6px', fontSize: '14px',
            fontWeight: '500', textDecoration: 'none'
          }}
        >
          Contact Support
        </a>
      </div>
    </div>
  )

  return children
}
